import { type ReactNode } from 'react'
import { Grid, Paper, Stack, Typography } from '@mui/material'

const leftColumnSize = { xs: 12, lg: 3 }
const rightColumnSize = { xs: 12, lg: 9 }

interface FormSectionProps {
  title?: string
  description?: string
  paperless?: boolean
  children: ReactNode
}

export function FormSection({
  title,
  description,
  paperless,
  children
}: FormSectionProps) {
  const content = (
    <Stack direction="column" gap={3}>
      {children}
    </Stack>
  )

  return (
    <Grid container spacing={{ xs: 4, lg: 8 }}>
      <Grid size={leftColumnSize}>
        <Typography variant="h6" component="h2" color="primary" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Grid>
      <Grid size={rightColumnSize}>
        {paperless ? content : <Paper sx={{ p: 3 }}>{content}</Paper>}
      </Grid>
    </Grid>
  )
}
